<template>
  <div>
    <div class="dorm-tab__list">
      <div
        v-for="movie in shows"
        :key="movie.id"
        class="dorm-tab__col col-xl-3 col-lg-3 col-md-3"
        :class="{
        'col-xl-12 col-lg-12 col-md-12 col-sm-12' : shows.banners && shows.banners.length > 0,
        empty : movie.banners && movie.banners.length <= 0
      }">
        <network-card :network="movie" v-if="!movie.banners"/>
        <div class="banner-section row" v-if="banners">
          <banner-item
            class="col-xl-6 col-lg-6 col-md-12 col-sm-12"
            v-for="banner in banners" :key="banner.id"
            :banner="banner"
            :to="{ name: 'MovieDetail', params: { slug: banner.slug, id: banner.id }}"
          />
        </div>
      </div>
      <empty-content :content="emptyContent" v-if="shows.length === 0"/>
    </div>
  </div>
</template>

<script>
import NetworkCard from '@/components/Network/NetworkCard'
import BannerItem from '@/components/BannerItem'
export default {
  name: 'ShowList',
  props: {
    shows: Array
  },
  components: {
    NetworkCard,
    BannerItem
  },
  data () {
    return {
      emptyContent: {
        icon: 'icon-search',
        title: 'No Result!',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda dolor, dolorem fugit in quis velit!'
      },
      bannersX: [
        {
          id: 1,
          color: 'red',
          top_title : 'Banner',
          bottom_title: 'Your Banner Here'
        }/*,
        {
          id: 2,
          color: 'blue',
          top_title : 'Banner 2',
          bottom_title: 'Your Banner Here'
        }
        {
          id: 3,
          color: 'red',
          top_title : 'Banner 3',
          bottom_title: 'Your Banner Here'
        },
        {
          id: 4,
          color: 'blue',
          top_title : 'Banner 4',
          bottom_title: 'Your Banner Here'
        }    */          
      ]
    }
  }
}
</script>

<style scoped>

</style>
